<route>
{
  "meta": {
    "permission": [
      "purchase.view_purchaseorder"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <v-row row wrap>
      <v-col cols="12" sm="3">
        <i-date-picker
          v-model="form.start"
          :label="$tc('start_date', 1)"
          color="primary"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <i-date-picker
          v-model="form.end"
          :label="$t('end_date')"
          color="primary"
          :min="start"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="code"
          :name="$t('code')"
          rules=""
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.code"
            outlined
            :error-messages="errors[0]"
            :label="$t('code')"
            class="secondary--text"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="supplier"
          :name="$tc('supplier', 1)"
          rules=""
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.supplier"
            outlined
            :error-messages="errors[0]"
            :label="$tc('supplier', 1)"
            class="secondary--text"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="name"
          :name="$tc('product', 1)"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.product"
            outlined
            :error-messages="errors[0]"
            :label="$tc('product', 1)"
            class="secondary--text"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn color="secondary" @click="clear">
          {{ $t('clear') }}
        </v-btn>
      </v-col>
    </v-row>
    <i-table
      :title="$t('purchaseHistory')"
      :headers="headers"
      app="purchase.purchaseorder"
      api="purchase.product"
      :opt="{
        company_id: this.company.pk,
        code: this.form.code,
        order__mainStatus: this.form.status,
        received_date__gte: this.form.start,
        received_date__lte: this.form.end,
        order__supplier__company_name: this.form.supplier,
        product__name: this.form.product
      }"
      dontCreate
      dontRemove
      dontEdit
      dontSearch
    >
      <template v-slot:extraToolbar>
        <v-divider class="mx-4" inset vertical></v-divider>
        <i-btn
          text
          :small="$vuetify.breakpoint.smAndDown"
          icon="fa-file-excel"
          :title="$t('download', { value: $t('purchasesReport') })"
          color="text-dark"
          @click="getPurchaseOrdersExcel()"
        >
        </i-btn>
        <i-btn
          text
          :small="$vuetify.breakpoint.smAndDown"
          icon="fa-file-pdf"
          :title="$t('download', { value: $t('purchasesReport') })"
          color="text-dark"
          @click="getPurchaseOrdersPDF()"
        >
        </i-btn>
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      form: {
        product: '',
        code: '',
        start: '',
        end: '',
        supplier: '',
        status: 'finished'
      }
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('order_code'),
          value: 'code'
        },
        {
          text: this.$t('order_name'),
          value: 'projectName'
        },
        {
          text: this.$tc('supplier', 1),
          value: 'infoSupplierName'
        },
        {
          text: this.$t('dateOrder'),
          value: 'orderDate'
        },
        {
          text: this.$tc('product', 1),
          value: 'own_prod'
        },
        {
          text: this.$tc('price', 1),
          value: 'price',
          align: 'right'
        },
        {
          text: this.$tc('quantity', 1),
          value: 'quantity',
          align: 'right'
        },
        {
          text: this.$tc('received_quantity', 1),
          value: 'received_quantity',
          align: 'right'
        },
        {
          text: this.$tc('received_date', 1),
          value: 'received_date'
        },
        {
          text: this.$tc('subtotal', 1),
          value: 'subtotal',
          align: 'right'
        }
      ]
    },
    ...mapGetters({
      company: 'company/getCompanyData'
    })
  },
  methods: {
    getPurchaseOrdersExcel() {
      this.downloadFile({
        api: 'purchase.product',
        method: 'historyExcel',
        filename: 'PurchaseHistory',
        action: 'download',
        ext: 'xlsx',
        opt: {
          pk: this.company.pk,
          params:
            '?code=' +
            encodeURIComponent(this.form.code) +
            '&status=' +
            encodeURIComponent(this.form.status) +
            '&received_date__gte=' +
            encodeURIComponent(this.form.start) +
            '&received_date__lte=' +
            encodeURIComponent(this.form.end) +
            '&supplier=' +
            encodeURIComponent(this.form.supplier) +
            '&product=' +
            encodeURIComponent(this.form.product)
        }
      })
    },
    getPurchaseOrdersPDF() {
      this.downloadFile({
        api: 'purchase.product',
        method: 'historyPdf',
        filename: 'PurchaseHistory',
        action: 'download',
        ext: 'pdf',
        opt: {
          pk: this.company.pk,
          params:
            '?code=' +
            encodeURIComponent(this.form.code) +
            '&status=' +
            encodeURIComponent(this.form.status) +
            '&received_date__gte=' +
            encodeURIComponent(this.form.start) +
            '&received_date__lte=' +
            encodeURIComponent(this.form.end) +
            '&supplier=' +
            encodeURIComponent(this.form.supplier) +
            '&product=' +
            encodeURIComponent(this.form.product)
        }
      })
    },
    clear() {
      this.form = {
        product: '',
        code: '',
        start: '',
        end: '',
        supplier: '',
        status: 'finished'
      }
    }
  }
}
</script>
